import { z } from 'zod';

export const ChangeAssigneeModalSchema = z.object({
  assignee: z.object(
    {
      label: z.string(),
      value: z.string(),
    },
    { message: 'กรุณาเลือก Assignee' },
  ),
});

export type ChangeAssigneeModalFormValues = z.infer<typeof ChangeAssigneeModalSchema>;
